export default {"src":"/_next/static/media/care-team-at-work-functional.mono.14ed9a7d.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};